import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=0b866288&scoped=true&lang=pug"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"
import style0 from "./Stats.vue?vue&type=style&index=0&id=0b866288&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b866288",
  null
  
)

export default component.exports